import {Injectable} from "@angular/core";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {GetCurrentDeliveryPointUseCase} from "@app/core/delivery-point/application/get-current-delivery-point.use-case";
import {GetDeliveryPointsUseCase} from "@app/core/delivery-point/application/get-delivery-points.use-case";
import {SaveDeliveryPointUseCase} from "@app/core/delivery-point/application/save-delivery-point.use-case";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {BehaviorSubject, Observable} from "rxjs";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";

@Injectable({
    providedIn: 'root'
})
export class DeliveryPointsViewModel {

    public notifier = new PopupNotifier()

    private readonly isDeliveryPointsLoadingSubject = new BehaviorSubject<boolean>(false);
    readonly isDeliveryPointsLoading$ = this.isDeliveryPointsLoadingSubject.asObservable();

    constructor(
        private getDeliveryPointsUseCase: GetDeliveryPointsUseCase,
        private saveDeliveryPointUseCase: SaveDeliveryPointUseCase,
        private getCurrentDeliveryPointUseCase: GetCurrentDeliveryPointUseCase
    ) { }

    getDeliveryPoints(): Observable<DeliveryPoint[]> {
        return this.getDeliveryPointsUseCase.execute().pipe(
            onIsLoadingChanges(isLoading => this.isDeliveryPointsLoadingSubject.next(isLoading)),
            onError(error => this.notifier.notifyError(error))
        );
    }

    getCurrentDeliveryPoint(): Observable<DeliveryPoint | null> {
        return this.getCurrentDeliveryPointUseCase.execute();
    }

    saveDeliveryPoint(deliveryPoint: DeliveryPoint) {
        this.saveDeliveryPointUseCase.execute({deliveryPoint, sendDeliveryPoint: true}).subscribe();
    }

}
